import { Field, ImageField, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';

import { SitecoreFieldTypes } from '@gn-audio/jss-components';
import { ComponentProps } from '@gn-audio/jss-components/lib/component-props';

export type CategoryPromoCarouselProps = {
  items: CategoryPromoSpotItem[];
};

export type CategoryPromoSpotSliderButtonProps = {
  direction: 'left' | 'right';
  onClick: () => void;
  disabled: boolean;
};
export type CategoryPromoSpotProps = {
  fields: SitecoreFieldTypes;
} & ComponentProps;

export type CategoryPromoSpotFields = {
  title: Field<string>;
  categoryPromoItems: CategoryPromoSpotItem[];
};

export type CategoryPromoSlidesGroup = {
  items: CategoryPromoSpotItem[];
  id: string;
};

export type CategoryPromoSpotItem = {
  id: string;
  title: Field<string>;
  description: Field<string>;
  image: ImageField;
  url: LinkField;
};
export type CategoryPromoSlidesProps = {
  items: CategoryPromoSpotItem[];
  isActive: boolean;
};
